import ErrorProvider from "./ErrorProvider";

export default ErrorProvider;
